module.exports = __webpack_public_path__ + "img/img19.b5e38a33.png";